export default "__VITE_ASSET__4e496c01__"